//Types
export const SELLER_LOADING = "SELLER_LOADING";
export const SELLER_LOADED = "SELLER_LOADED";
export const S_LOGIN_SUCCESS = "S_LOGIN_SUCCESS";
export const S_LOGIN_FAIL = "S_LOGIN_FAIL";
export const S_REGISTER_SUCCESS = "S_REGISTER_SUCCESS";
export const S_REGISTER_FAIL = "S_REGISTER_FAIL";
export const S_LOGOUT_SUCCESS = "S_LOGOUT_SUCCESS";
export const GENERAL_SELLER_REDUCER = "GENERAL_SELLER_REDUCER";
export const AUTH_ERROR = "AUTH_ERROR";
